/**
 * @file HeaderToggle.js
 *
 * This file will insert the appropriate toggles into the header
 * when on mobile after the appropriate event is fired.
 *
 * @author Stanley Clark <stanley@studyportals.com>
 * @copyright © 2016-2017 StudyPortals B.V., all rights reserved.
 * @version 1.1.0
 */

(function () {
	// Gather toggle items on the page and see if we need to do anything

	const toggleItems = Array.from(document.getElementsByClassName('js-HeaderToggleItem'));
	if (toggleItems.length === 0) {
		return;
	}

	// Check if there is an equal amount of content to go with the toggles

	const toggleContent = Array.from(document.getElementsByClassName('HeaderToggleContent'));
	if (toggleContent.length !== toggleItems.length) {
		return;
	}

	// Set the main container

	const container = document.getElementById('HeaderToggle');
	if (!container) {
		return;
	}

	Array.from(toggleItems).forEach((el) => container.insertBefore(el, null));

	Array.from(toggleItems).forEach((toggleItem) => {
		let LoggedIn = false;

		container.appendChild(toggleItem);

		toggleItem.classList.add('MobileOnlyBlock');
		toggleItem.classList.remove('Hidden');

		LoggedIn = isUserLoggedIn();

		if (LoggedIn && hasUserIcon(toggleItem)) {
			let userIcon = toggleItem.querySelector('i.lnr-user');
			userIcon.classList.remove('lnr-user');
			userIcon.classList.add('lnr-user-full');
		} else {
			window.AuthController.subscribe(function (error, data) {
				if (data && data.LoggedInStatus === true && hasUserIcon(toggleItem)) {
					let userIcon = toggleItem.querySelector('i.lnr-user');
					userIcon.classList.remove('lnr-user');
					userIcon.classList.add('lnr-user-full');
				}
			});
		}

		toggleItem.addEventListener('click', function () {
			let toHide = false;

			// Special behaviour forTuition Preferences

			if (this.classList.contains('js-preferences') || this.classList.contains('js-wishlistButton')) {
				return;
			}

			if (this.classList.contains('InView')) {
				toHide = true;
			}

			closeCurrentView();

			if (toHide) {
				return;
			}

			this.classList.add('InView');

			toggleContent[toggleItems.indexOf(this)].classList.add('InView');
		});
	});

	function isUserLoggedIn() {
		if (window.AuthController === undefined) {
			return false;
		}

		let loggedIn = false;

		loggedIn = window.AuthController.isLoggedIn();

		return loggedIn;
	}

	function hasUserIcon($Element) {
		if ($Element.querySelector('i.lnr-user') === null) {
			return false;
		}

		return true;
	}

	// Set relay for all buttons that are stored in $buttonWrapper.
	document.addEventListener('click', function (event) {
		if (!event.target.closest('.HeaderToggleContent') && !event.target.closest('.js-HeaderToggleItem')) {
			closeCurrentView();
		}
	});

	document.addEventListener('url_change', () => {
		closeCurrentView();
	});

	function closeCurrentView() {
		toggleContent.forEach((toggleContentItem) => {
			toggleContentItem.classList.remove('InView');
		});

		toggleItems.forEach((toggleContentItem) => {
			toggleContentItem.classList.remove('InView');
		});
	}
})();
